import { useState, useEffect } from 'react';
import api from '../services/api';

export const usePermissions = () => {
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/auth/mes-permissions')
      .then(res => setPermissions(res.data))
      .catch(() => setPermissions({}))
      .finally(() => setLoading(false));
  }, []);

  const peut = (module, action) => {
    if (!permissions) return false;
    if (permissions._isAdmin) return true;
    return permissions[module]?.[action] === true;
  };

  return { permissions, loading, peut };
};
